const key = 'USER__';

exports.USER_UPDATE = `${key}UPDATE`;
exports.USER_LOGOUT = `${key}LOGOUT`;
exports.USER_SET_CLIENT = `${key}SET_CLIENT`;
exports.USER_CREATE_EDIT_USER = `${key}CREATE_EDIT_USER`;
exports.USER_EDIT_ID = `${key}EDIT_ID`;

exports.SET_FIRST_TIME = `${key}SET_FIRST_TIME`;
